import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../util/api";
import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";

export const tryLogin = createAsyncThunk("authentication/tryLogin", async loginData => {
    const response = await api.post(`v2/api/auth`, loginData).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});

export const renewToken = createAsyncThunk("authentication/renewToken", async loginData => {
    const response = await api.post(`v2/api/auth/renew`, loginData).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});

const initialState = {
    token: null,
    externalToken: null,
    status: {
        type: "idle",
        error: null,
    },
};
const authenticationSlice = createSlice({
    name: "authentication",
    initialState,
    reducers: {
        setInitialState: state => initialState,
        setToken: (state, action) => {
            state.token = action.payload
        },
        setExternalToken: (state, action) => {
            state.externalToken = action.payload
        },
    },
    extraReducers: {
        [tryLogin.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [tryLogin.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.token = action.payload.data.token;
        },
        [tryLogin.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },

        [renewToken.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [renewToken.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.token = action.payload.data.token;
        },
        [renewToken.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
    },
});

export const {setInitialState, setToken, setExternalToken} = authenticationSlice.actions;
export default persistReducer(
    {
        key: "authentication",
        storage,
    },
    authenticationSlice.reducer
);
